// extracted by mini-css-extract-plugin
export default {"contenedor":"navbar_contenedor__JWYcQ","botones":"navbar_botones__5tUzH","boton_container":"navbar_boton_container__wEAaC","boton":"navbar_boton__0ICa3"};